<template>
  <Modal ref="modal" :show="show" @close="$emit('close')" class="alt-header">
    <div class="modal-header row no-gutters">
      <div class="col-auto">
        <h3 class="m-0">Copy referral</h3>
      </div>
      <div class="col text-right">
        <a @click="$emit('close')" title="Close" href="javascript:void(0)">
          <font-awesome-icon :icon="['far', 'times']" size="2x" />
        </a>
      </div>
    </div>
    <div class="modal-body row h-100 overflow-hidden">
      <div class="row h-100 no-gutters">
        <div class="col-9 h-100 overflow-auto">
          <div class="d-block mx-auto h-100">
            <div class="d-flex h-100 w-100">
              <PickReferringOffice
                @selected="selectedOffice"
                :preselected="offices.map((s) => s.id)"
                :redirect="''"
                :title="null"
                subtitle="Who would you like to send a copy to?"
                class="flex-grow-1"
                :showAdd="false"
                :isInModal="true"
              />
            </div>
          </div>
        </div>
        <div class="col-3 p-2 d-flex flex-column" style="border-left: 1px solid var(--border-color)">
          <div class="office-list border rounded p-3 mt-auto">
            <h6>Selected offices</h6>
            <small class="text-muted" v-if="!offices.length">Select an office to copy to</small>
            <div v-for="o in offices" :key="o.id" class="d-flex align-items-center mb-1">
              <span class="flex-grow-1 text-overflow">{{ o.name }}</span>
              <a href="javascript:void(0)" @click="selected(o)">
                <font-awesome-icon :icon="['far', 'times']" />
              </a>
            </div>
          </div>
          <div class="border rounded p-3 mt-3" :class="{ disabled: !referral.attachments.length }">
            <div class="form-check text-right pl-0 d-flex">
              <div
                class="custom-control custom-switch custom-switch-md justify-content-center align-self-center"
                style="cursor: pointer"
              >
                <input
                  v-model="isAttachmentsIncluded"
                  type="checkbox"
                  class="custom-control-input"
                  name="is_important"
                  id="Switch-important-patient"
                  :disabled="!referral.attachments.length"
                />
                <label
                  class="custom-control-label"
                  for="Switch-important-patient"
                  style="cursor: pointer; font-weight: bold"
                  >Include attachments</label
                >
              </div>
            </div>
            <small class="d-block mt-1">Include attachments on the new copy.</small>
          </div>
        </div>
      </div>
    </div>
    <div class="row modal-footer">
      <div class="col p-0">
        <div class="row no-gutters">
          <div class="col-auto text-left">
            <div class="alert alert-info mb-0" style="">
              <b>This will not send a referral</b> - an unsent copy will be created, you will need to send it.
            </div>
          </div>
          <div class="col text-right">
            <button
              class="btn btn-primary btn-lg"
              style="padding: 0.85rem 1.75rem"
              @click.stop="copy"
              :disabled="isCopying || !offices.length"
              data-v-tour="confirmReferral"
            >
              <font-awesome-icon icon="spinner-third" v-if="isCopying" spin />
              <span v-else>Copy referral</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal'
import PrintReferral from '@/views/referrals/PrintReferral'
import PickReferringOffice from '@/views/referrals/PickReferringOffice'

import { ReferralApi } from '@/services'
import { mapGetters } from 'vuex'
export default {
  props: {
    show: { type: Boolean, default: true },
    referralId: { required: true },
  },
  components: {
    Modal,
    PrintReferral,
    PickReferringOffice,
  },
  data() {
    return {
      isAttachmentsIncluded: false,
      isCopying: false,
      offices: [],
    }
  },
  mounted() {
    this.isAttachmentsIncluded = !!this.referral?.attachments?.length
  },
  computed: {
    ...mapGetters('referrals', ['all', 'get']),
    referral() {
      return this.get(this.referralId)
    },
  },
  methods: {
    async copy() {
      if (!this.offices?.length) return
      this.isCopying = true
      try {
        const newReferrals = await ReferralApi.saveRelated(this.referralId, 'copy', {
          include_attachments: this.isAttachmentsIncluded,
          practices: this.offices.map((s) => s.id),
        })
        this.$helpers.success('Referral copied successfully')
        newReferrals.map((s) => this.$store.commit('referrals/saveReferral', s))
        this.$router.push('/referral/' + newReferrals[0].id)
      } catch (err) {
        this.$exception(err)
        this.$helpers.error('Failed to copy referral')
      }
      this.isCopying = false
    },
    selectedOffice(office) {
      const index = this.offices.findIndex((s) => s.id == office.id)

      if (index === -1) this.offices.push(office)
      else this.offices.splice(index, 1)
    },
  },
}
</script>

<style >
.modal-body .pick-referring-office .specialty-card {
  background: #ffffff;
  border-radius: 10px;
  text-align: center;
  font-size: 0.875rem;
  font-weight: bolder;
  color: var(--body-color);
  padding: 0.75rem 1rem;
  box-sizing: border-box;
  margin: 1px;
}
.modal-body .pick-referring-office .specialties {
  display: none;
}
.modal-body .pick-referring-office .specialties > .col-12 {
  padding-right: 0;
  padding-left: 0;
}
.modal-body .pick-referring-office .doctor-list-container,
.modal-body .pick-referring-office .item-phone,
.modal-body .pick-referring-office .item-website {
  display: none !important;
}
.modal-body .pick-referring-office .item-meta {
  font-size: 0.875rem !important;
}
.modal-body .pick-referring-office .item-address {
  max-width: 20vw;
  display: inline-block;
}
.modal-body .pick-referring-office .item-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 30vw;
  overflow: hidden;
}

.modal-body .dropdown.show .dropdown-menu {
  z-index: 10001 !important;
}

.modal-body .pick-referring-office .more-options {
  display: none;
}
</style>

<style lang="scss" scoped>
.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>